import {TableCell, TableRow} from "@material-ui/core";
import PropTypes from "prop-types";
import React, {useState} from "react";
import UploadFile from "components/UploadFile";
import OffersChoiceResultService from "services/OffersChoiceResultService";
import Tr from "translations/Translations";
import OfferChoiceResultFilesTable from "./OfferChoiceResultFilesTable";
import BoldTypography from "components/BoldTypography";

function OfferChoiceResultFiles(
    {
        demandId,
        editable,
        working,
        offerChoiceResultItem,
        files,
        setFiles,
        showShare,
        canDownloadFile
    }) {

    const [filesWorking, setFilesWorking] = useState(false);


    const handleSendFiles = (files) => {
        if (files.length) {
            setFilesWorking(true);
            OffersChoiceResultService.addChoiceResultFilesList(demandId, offerChoiceResultItem.identity, files)
                .then((resp) => {
                    if (resp)
                        setFiles(state => [...state, ...resp.files]);
                })
                .finally(() => setFilesWorking(false));
        }
    }


    if (!files) return null;
    return (<TableRow>
        <TableCell colSpan={7}>
            {editable && files && <UploadFile
                disabled={working}
                onUploadPopupClosed={handleSendFiles}
                working={filesWorking}
            />
            }
            {
                !files.length ?
                    <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>
                    :
                    <OfferChoiceResultFilesTable
                        demandId={demandId}
                        files={files}
                        setFiles={setFiles}
                        working={working}
                        offerChoiceResultItem={offerChoiceResultItem}
                        editable={editable}
                        showShare={showShare}
                        canDownloadFile={canDownloadFile}
                    />
            }
        </TableCell>
    </TableRow>)
}

OfferChoiceResultFiles.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool.isRequired,
    offerChoiceResultItem: PropTypes.object.isRequired,
    files: PropTypes.arrayOf(PropTypes.shape({
        identity: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        datePublished: PropTypes.string
    })),
    setFiles: PropTypes.func.isRequired
}

export default OfferChoiceResultFiles;

